import type { AppRouter } from 'server/trpc/routers';
import superjson from 'superjson';
import { createTRPCNuxtClient, httpBatchLink } from 'trpc-nuxt/client';

export default defineNuxtPlugin(() => {
  const headers = useRequestHeaders();
  const trpc = createTRPCNuxtClient<AppRouter>({
    links: [
      httpBatchLink({
        url: '/api/trpc',
        transformer: superjson,
        headers() {
          return {
            ...headers,
            credentials: 'same-origin',
          };
        },
      }),
    ],
  });

  return {
    provide: {
      trpc,
    },
  };
});
